import { IconArrowLeft } from "@tabler/icons-react";
import type { ReactNode } from "react";
import type { AuthMethod, AuthStep } from "@/hooks/auth/useAuthModal";

type GetAuthModalConfigParams = {
  step: AuthStep;
  otpPhone: string;
  otpEmail: string;
  authMethod: AuthMethod | null;
  onBackToLogin: () => void;
  onBackFromOtp: () => void;
};

type AuthModalConfig = {
  title: string;
  description?: string;
  headerStart: ReactNode;
};

/**
 * Get auth modal config
 * @param param0 GetAuthModalConfigParams
 * @returns AuthModalConfig
 */
export const getAuthModalConfig = ({
  step,
  otpPhone,
  otpEmail,
  authMethod,
  onBackToLogin,
  onBackFromOtp,
}: GetAuthModalConfigParams): AuthModalConfig => {
  switch (step) {
    case "register":
      return {
        title: "Create Account",
        description: "Enter your phone number to sign up for Tovtrip.",
        headerStart: (
          <button type="button" onClick={onBackToLogin} aria-label="Back">
            <IconArrowLeft stroke={1.8} size={32} />
          </button>
        ),
      };

    case "otp":
      return {
        title: "Enter OTP",
        description:
          authMethod === "email"
            ? `We've sent a verification code to ${otpEmail}`
            : `We've sent a verification code to +855 ${otpPhone}`,
        headerStart: (
          <button type="button" onClick={onBackFromOtp} aria-label="Back">
            <IconArrowLeft stroke={1.8} size={32} />
          </button>
        ),
      };

    case "create-password":
      return {
        title: "Create Password",
        description: "Set a secure password for your account",
        headerStart: (
          <button
            type="button"
            className="flex items-center justify-center p-2 text-[#464C53]"
            onClick={onBackToLogin}
          >
            <IconArrowLeft stroke={2} size={24} />
          </button>
        ),
      };

    case "forgot-password":
    case "reset-password":
      return {
        title: "Reset password",
        description: undefined,
        headerStart: (
          <button
            type="button"
            className="flex items-center justify-center p-2 text-[#464C53]"
            onClick={onBackToLogin}
            aria-label="Back"
          >
            <IconArrowLeft stroke={2} size={24} />
          </button>
        ),
      };

    case "login":
    default:
      return {
        title: "Login",
        description: undefined,
        headerStart: null,
      };
  }
};
